import {
  RECEIVE_HOTEL_DATE_PRICES,
  RECEIVE_HOTEL_DATE_PRICES_EMPTY,
  RECEIVE_HOTEL_DATE_PRICES_ERROR,
  REQUEST_HOTEL_DATE_PRICES_DATA,
} from '../helpers/constants/actionsConstants';
import { VALID_HOTELS_DATE_PRICES_ERRORS } from '../helpers/constants/dataTypeConstants';

import type {
  HotelsDatePricesAction,
  ReceiveHotelDatePricesAction,
  ReceiveHotelDatePricesErrorAction,
} from '../actions/types';
import type { DateData, HotelsDatePricesState } from '../selectors/types';

const initialState: HotelsDatePricesState = {
  isFetching: true,
  error: null,
  dateData: {} as DateData,
};

const setLoadingState = (
  state: HotelsDatePricesState,
): HotelsDatePricesState => ({
  ...state,
  isFetching: true,
  error: null,
  dateData: {} as DateData,
});

const setEmptyState = (
  state: HotelsDatePricesState,
): HotelsDatePricesState => ({
  ...state,
  isFetching: false,
  error: null,
  dateData: {} as DateData,
});

const parseHotelsDatePrices = (
  state: HotelsDatePricesState,
  action: ReceiveHotelDatePricesAction,
): HotelsDatePricesState => ({
  ...state,
  isFetching: false,
  error: null,
  dateData: action.payload,
});

const setErrorState = (
  state: HotelsDatePricesState,
  action: ReceiveHotelDatePricesErrorAction,
): HotelsDatePricesState => {
  if (VALID_HOTELS_DATE_PRICES_ERRORS.indexOf(action.payload.error) === -1) {
    return state;
  }

  return {
    ...state,
    isFetching: false,
    error: action.payload.error,
    dateData: {} as DateData,
  };
};

const reducer = (
  state: HotelsDatePricesState = initialState,
  action: HotelsDatePricesAction,
): HotelsDatePricesState => {
  switch (action.type) {
    case `${REQUEST_HOTEL_DATE_PRICES_DATA}_STARTED`:
      return setLoadingState(state);

    case RECEIVE_HOTEL_DATE_PRICES:
      return parseHotelsDatePrices(state, action);

    case RECEIVE_HOTEL_DATE_PRICES_EMPTY:
      return setEmptyState(state);

    case RECEIVE_HOTEL_DATE_PRICES_ERROR:
      return setErrorState(state, action);

    default:
      return state;
  }
};

export default reducer;
